import { inject, Injectable } from '@angular/core';
import { FileHttpService } from '../http/file-http.service';

@Injectable({
    providedIn: 'root'
})
export class UploadService {
    private fileHttpService = inject(FileHttpService);

    /**
     * Uploads the given files to a temporary in-memory-storage on the backend. And return an array of guids that should be used, when the files should be used.
     * @param files
     * @param userGenericErrors
     */
     uploadFiles(files: File[], userGenericErrors = true): Promise<string[]> {
        return this.fileHttpService.upload('/api/upload/upload-files', files, undefined, userGenericErrors);
    }
}
